import { MimeTypes } from 'src/@vymo/ui/molecules/documentUploader/constants';
import heic2any from 'heic2any';

export const getIsFilePreviewSupported = (file: File) => {
  switch (file?.type) {
    case MimeTypes.DOC:
    case MimeTypes.DOCX:
    case MimeTypes.PPT:
    case MimeTypes.PPTX:
    case MimeTypes.XLS:
    case MimeTypes.XLSX:
      return false;

    default:
      return true;
  }
};

export async function getHeicPreviewUrl(file: File): Promise<string> {
  if (
    file.type === 'image/heic' ||
    file.type === 'image/heif' ||
    file.name.endsWith('.heic') ||
    file.name.endsWith('.heif')
  ) {
    const convertedBlob = await heic2any({ blob: file, toType: 'image/jpeg' });
    return URL.createObjectURL(convertedBlob as Blob);
  }

  return URL.createObjectURL(file);
}

export const getDecodedString = (rawString) => {
  try {
    const decodedString = decodeURIComponent(rawString);
    return decodedString;
  } catch {
    return rawString;
  }
};
